import tw from 'twin.macro';

const List = tw.ul`list-disc list-outside my-6 ml-8`;

export default List;
